import React from "react";

function ContractEnquiry() {
  return <div></div>;
}

export default ContractEnquiry;
